/* eslint react/no-unknown-property: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import InternalLinkLib from './internal-link-lib';


class InternalLink extends React.Component {

  handleAnchorClick() {
    const { to: internalRoute, onBeforeNavigation } = this.props;
    if (onBeforeNavigation) {
      onBeforeNavigation();
    }
    InternalLinkLib.goToInternalRoute(internalRoute);
  }

  render() {
    const { className, 'automation-id': automationTag } = this.props;
    return (
      <a className={className}
         automation-id={automationTag}
         onClick={() => this.handleAnchorClick()}
      >{this.props.children}</a>
    );
  }
}

InternalLink.propTypes = {
  to: PropTypes.string,
  history: PropTypes.object,
  location: PropTypes.object,
  className: PropTypes.string,
  onBeforeNavigation: PropTypes.func,
  serverPathname: PropTypes.string,
  'automation-id': PropTypes.string,
  children: PropTypes.node/*PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string,
    PropTypes.node
  ])*/,
};

export default InternalLink;
